module.exports = __webpack_public_path__ + "img/liftIcon16.e4163622.png";